export default "__VITE_ASSET__CWJji2cm__"